var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShortLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 67,
    viewBox: "0 0 63 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4522 34.7071H0V24.071C0 24.071 5.61422e-05 11.3309 12.6039 11.3309H40.7646L18.4522 34.7071Z",
    fill: "#0171CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0195312 38.5098V50.5936H14.4763L48.2924 14.7862L57.8273 0L18.3559 38.5098H0.0195312Z",
    fill: "#FFB40D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0195312 54.8015V66.8853H29.4542V46.173L54.4882 21.1561L60.6261 9.28467L14.9009 54.6857L0.0195312 54.8015Z",
    fill: "#0171CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.332 47.2543V66.8856H43.4846C43.4846 66.8856 55.4514 64.5113 55.4514 51.9063V30.5377L62.9983 19.1102L33.332 47.2543Z",
    fill: "#0171CE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortLogo);
export default __webpack_public_path__ + "static/media/shortLogo.428c28387801f590763041c1f1291b33.svg";
export { ForwardRef as ReactComponent };